import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { init } from '@sentry/browser';
import registerServiceWorker from './registerServiceWorker';

import "@babel/polyfill"; 
 
init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: process.env.REACT_APP_VERSION,
  environment: process.env.NODE_ENV,
});

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js